import { readFile, writeFile } from 'fs/promises';

/**
 * Convert AGENTS.md to MEMORY.md
 *
 * AGENTS.md is standard markdown without @import syntax.
 * We can directly copy the content to MEMORY.md.
 *
 * @param sourcePath - Path to AGENTS.md
 * @param targetPath - Path to output MEMORY.md
 */
export async function agentsToMemory(sourcePath: string, targetPath: string): Promise<void> {
  try {
    // Read AGENTS.md content
    const content = await readFile(sourcePath, 'utf-8');

    // MEMORY.md format is compatible with AGENTS.md
    // Just copy the content directly
    await writeFile(targetPath, content, 'utf-8');
  } catch (error) {
    throw new Error(
      `Failed to convert AGENTS.md to MEMORY.md: ${(error as Error).message}`
    );
  }
}
